import { PaginationParams, PaginationResponse } from '../../models/pagination'
import {
  CalculatorType,
  CreateCalculatorType,
  EditCalculatorType,
  GetAttractorsParamsType,
  PayoutUserType,
  SetCalculatorToUserType,
} from '../../models/payout'
import { clientApi } from './clientApi'

export const PayoutApi = {
  getCalcs(params: PaginationParams) {
    return clientApi.get<PaginationResponse<CalculatorType>>(
      '/web/payout/calcs/',
      {
        params,
      },
    )
  },
  setCalculatorToUser({ phone, future_calc }: SetCalculatorToUserType) {
    return clientApi.post<PayoutUserType>(
      `/web/payout/users/${phone}/set_calculator/`,
      { future_calc },
    )
  },
  getAllUsers(params: GetAttractorsParamsType) {
    return clientApi.get<PaginationResponse<PayoutUserType>>(
      '/web/payout/users/',
      {
        params,
      },
    )
  },
  getUsersCountWithoutCalc(params?: GetAttractorsParamsType) {
    return clientApi.get<{
      count: number
    }>('/web/payout/users/no_calcs/', {
      params,
    })
  },
  getCalcById(id: number) {
    return clientApi.get<CalculatorType>(`/web/payout/calcs/${id}/`)
  },
  editCalc(plan_id: number | string, plan: EditCalculatorType) {
    return clientApi.patch<CalculatorType>(
      `/web/payout/calcs/${plan_id}/`,
      plan,
    )
  },
  createCalc(body: CreateCalculatorType) {
    return clientApi.post<CalculatorType>(`/web/payout/calcs/`, body)
  },
  deleteCalc(id: number | string) {
    return clientApi.delete(`/web/payout/calcs/${id}/`)
  },
  downloadExcel(params: GetAttractorsParamsType) {
    return clientApi.get(`/web/payout/users/calcs_type_excel/`, {
      responseType: 'blob',
      params,
    })
  },
}
